/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_ProcessingInputs */



/**
* | output |
* | --- |
* | "Processing loudness analysis data..." |
*
* @param {Audio_Description_Export_Loudness_ProcessingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_processing = /** @type {((inputs?: Audio_Description_Export_Loudness_ProcessingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_ProcessingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement des données d'analyse de loudness...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verarbeitung von Lautheitsanalysedaten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione dei dati di analisi della rumorosità...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка данных анализа громкости...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Procesando datos de análisis de sonoridad...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在处理响度分析数据……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ラウドネス分析データを処理しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ध्वनि विश्लेषण डेटा संसाधित किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processamento de dados de análise de intensidade sonora...")
	return /** @type {LocalizedString} */ ("Processing loudness analysis data...")
});